
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/library/history",
      function () {
        return require("private-next-pages/library/history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/library/history"])
      });
    }
  